<template>
  <v-container fluid>
    <v-row class="px-0 py-0 my-0">
      <v-col cols="12" class="d-md-flex">
        <RangeFilter 
          :end="dateEnd" 
          :start="dateStart" 
          @getDates="getDates" 
          :excludePeriod="excludePeriod"
          :defaultPeriod="defaultPeriod"
          :setDates="true"
          :disabled="loaded"
         />
        <v-switch
          v-model="isCompareFilter"
          hide-details
          color="orange darken-3"
          class="mx-5 mt-md-1 my-3 mb-md-0"
        >
          <template #label>
            <span class="ml-1">Compare</span>
          </template>
        </v-switch>
        <CompareFilter
          v-if="isCompareFilter"
          :end="dateCompareEnd"
          :start="dateCompareStart"
          :periodStart="dateStart"
          :periodEnd="dateEnd"
          @getDates="getCompareDates"
          :bgColor="compareFilterColor"
          :filterIcon="compareIcon"
          :diffDays="diffDays"
          :disabled="loadedCompare"
        />
      </v-col>
    </v-row>
    <div class="row">
      <div class="col-12 d-flex flex-wrap">
        <div class="ml-2" v-for="card in cards.filter(x=>!x.isVisible)" :key="card.value">
          <v-chip outlined @click="showCard(card)">
            <v-icon left>mdi-eye</v-icon> {{ card.title }}
          </v-chip>
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap justify-space-between mt-sm-7">
      <v-card class="calls-card rounded-lg elevation-2 d-flex flex-column mb-5"           
              :loading="loaded || loadedCompare" loader-height="1"
              v-for="card in cards.filter(x=>x.isVisible)"
              :key="card.value"
      >
        <v-card-title class="calls-card-title pa-0">
          <div class="row">
            <div class="col-11 pa-0">{{ card.title }}</div>
            <div class="col-1  pa-0">
              <button @click="hideCard(card)"><v-icon>mdi-eye-off</v-icon></button>
            </div>
          </div>
        </v-card-title>
        <v-card-text class="calls-text-card pa-0 mt-auto">
          <div class="d-flex">
            <div v-if="card.pageName">
              <a @click="openPage(card.pageName)" target="_blank" style="text-decoration: underline;">
                <span v-if="!loaded && card.filter === 'formatPrice'">${{ data[card.value] | formatPrice }}</span>
                <span v-if="!loaded && card.filter === 'formatFloat'">{{ data[card.value] | formatFloat }}</span>
              </a>
              <div class="ml-1 align-self-center compare-text green--text text--darken-3" v-if="result[card.value_compare] > 0 && isCompareFilter && !loadedCompare && card.filter === 'formatPrice'">
                <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>{{ result[card.value_compare] | formatPrice }}
              </div>
              <div class="ml-1 align-self-center compare-text green--text text--darken-3" v-if="result[card.value_compare] > 0 && isCompareFilter && !loadedCompare && card.filter === 'formatFloat'">
                <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>{{ result[card.value_compare] | formatFloat }}
              </div>
              <div class="ml-1 align-self-center compare-text red--text text--darken-3" v-if="result[card.value_compare] < 0 && isCompareFilter && !loadedCompare && card.filter === 'formatPrice'">
                <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>{{ result[card.value_compare] | formatPriceAbs }}
              </div>
              <div class="ml-1 align-self-center compare-text red--text text--darken-3" v-if="result[card.value_compare] < 0 && isCompareFilter && !loadedCompare && card.filter === 'formatFloat'">
                <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>{{ result[card.value_compare] | formatFloatAbs }}
              </div>
              <div class="ml-1 align-self-center compare-text blue--text text--darken-3" v-if="result[card.value_compare] == 0 && isCompareFilter && !loadedCompare">0</div>
            </div>
            <div v-else>
              <span v-if="!loaded && card.filter === 'formatPrice'">${{ data[card.value] | formatPrice }}</span>
              <span v-if="!loaded && card.filter === 'formatFloat'">{{ data[card.value] | formatFloat }}</span>
              <div class="ml-1 align-self-center compare-text green--text text--darken-3" v-if="result[card.value_compare] > 0 && isCompareFilter && !loadedCompare && card.filter === 'formatPrice'">
                <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>{{ result[card.value_compare] | formatPrice }}
              </div>
              <div class="ml-1 align-self-center compare-text green--text text--darken-3" v-if="result[card.value_compare] > 0 && isCompareFilter && !loadedCompare && card.filter === 'formatFloat'">
                <v-icon class="compare-icon" color="green darken-2">mdi-arrow-up-thick</v-icon>{{ result[card.value_compare] | formatFloat }}
              </div>
              <div class="ml-1 align-self-center compare-text red--text text--darken-3" v-if="result[card.value_compare] < 0 && isCompareFilter && !loadedCompare && card.filter === 'formatPrice'">
                <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>{{ result[card.value_compare] | formatPriceAbs }}
              </div>
              <div class="ml-1 align-self-center compare-text red--text text--darken-3" v-if="result[card.value_compare] < 0 && isCompareFilter && !loadedCompare && card.filter === 'formatFloat'">
                <v-icon class="compare-icon" color="red darken-2">mdi-arrow-down-thick</v-icon>{{ result[card.value_compare] | formatFloatAbs }}
              </div>
              <div class="ml-1 align-self-center compare-text blue--text text--darken-3" v-if="result[card.value_compare] == 0 && isCompareFilter && !loadedCompare">0</div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import axios from '@/api/axios-auth'
import moment from 'moment'
import RangeFilter from '@/components/filters/RangePicker'
import CompareFilter from '@/components/filters/ComparePicker'

export default {
  components: {
    RangeFilter,
    CompareFilter
  },
  data() {
    return {
      isSelectCard: false,
      hideAnything: false,
      selected: [],
      data: [],
      dataCompare: [],
      result: [],
      historyChanged: [],
      userName: null,
      dateEnd: new Date().toISOString().substr(0, 10),
      dateStart: new Date(
                  Date.UTC(
                      new Date().getFullYear(),
                      new Date().getMonth(),
                      1)).toISOString().substr(0, 10),
      excludePeriod: [],
      defaultPeriod: 4,
      dateCompareEnd: new Date(
                    Date.UTC(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        0
                        )).toISOString().substr(0, 10),
      dateCompareStart: new Date(
                  Date.UTC(
                      new Date().getFullYear(),
                      new Date().getMonth()-1,
                      0
                      )).toISOString().substr(0, 10), 
      diffDays: 0,
      compareFilterColor: 'orange darken-3',
      defaultComparePeriod: 1,
      compareIcon: 'mdi-compare-vertical',
      isCompareFilter: false,
      loaded: false,
      loadedCompare: false,
      cards: [
        {title: 'Google Ads Expenses', value: 'expenses_total_adwords_ppc', value_compare: 'expenses_total_adwords_ppc_compare', filter: 'formatPrice', isVisible: true},
        {title: 'Bing Ads Expenses', value: 'expenses_total_bing_ppc', value_compare: 'expenses_total_bing_ppc_compare', filter: 'formatPrice', isVisible: true},
        {title: 'Total Expenses', value: 'expenses_total_ppc', value_compare: 'expenses_total_ppc_compare', filter: 'formatPrice', isVisible: true},
        {title: 'Total # of Google Ads clicks', value: 'total_adwords_clicks', value_compare: 'total_adwords_clicks_compare', filter: 'formatFloat', isVisible: true},
        {title: 'Total # of Bing Ads clicks', value: 'total_bing_clicks', value_compare: 'total_bing_clicks_compare', filter: 'formatFloat', isVisible: true},
        {title: 'Total # of PPC clicks', value: 'total_clicks', value_compare: 'total_clicks_compare', filter: 'formatFloat', isVisible: true},
        {title: 'Avg. Google Ads CPC', value: 'total_adwords_cpc', value_compare: 'total_adwords_cpc_compare', filter: 'formatPrice', isVisible: true},
        {title: 'Avg. Bing Ads CPC', value: 'total_bing_cpc', value_compare: 'total_bing_cpc_compare', filter: 'formatPrice', isVisible: true},
        {title: 'Avg. CPC', value: 'total_cpc', value_compare: 'total_cpc_compare', filter: 'formatPrice', isVisible: true},
        {title: 'Total # of Google Ads conversions', value: 'total_adwords_conv', value_compare: 'total_adwords_conv_compare', filter: 'formatFloat', isVisible: true},
        {title: 'Total # of Bing Ads conversions', value: 'total_bing_conv', value_compare: 'total_bing_conv_compare', filter: 'formatFloat', isVisible: true},
        {title: 'Total # of conversions', value: 'total_conv', value_compare: 'total_conv_compare', filter: 'formatFloat', isVisible: true},
        {title: 'Avg. Google Ads Cost per Conversion', value: 'total_adwords_conv_cost', value_compare: 'total_adwords_conv_cost_compare', filter: 'formatPrice', isVisible: true},
        {title: 'Avg. Bing Ads Cost per Conversion', value: 'total_bing_conv_cost', value_compare: 'total_bing_conv_cost_compare', filter: 'formatPrice', isVisible: true},
        {title: 'Avg. Cost per Conversion', value: 'total_conv_cost', value_compare: 'total_conv_cost_compare', filter: 'formatPrice', isVisible: true},
        {title: 'Total # of orders', value: 'total_of_orders', value_compare: 'total_of_orders_compare', filter: 'formatFloat', isVisible: true, pageName: 'sales'},
        {title: 'Total # of sold gallons', value: 'total_sold_gallons', value_compare: 'total_sold_gallons_compare', filter: 'formatFloat', isVisible: true, pageName: 'gallons'},
        {title: 'Revenue', value: 'total_sale_price', value_compare: 'total_sale_price_compare', filter: 'formatPrice', isVisible: true, pageName: 'sales'},
        {title: 'Avg. Cost per 1 gallon', value: 'total_ppc_one_gallon', value_compare: 'total_ppc_one_gallon_compare', filter: 'formatPrice', isVisible: true, pageName: 'activity'},
        {title: 'Avg. Cost per 1 Callrail In call', value: 'total_per_1_paid_call', value_compare: 'total_per_1_paid_call_compare', filter: 'formatPrice', isVisible: true},
        {title: 'Website inquires', value: 'inquires_total', value_compare: 'inquires_total_compare', filter: 'formatFloat', isVisible: true, pageName: 'call-center'},
        {title: 'CallRail calls', value: 'total_paid_callrail', value_compare: 'total_paid_callrail_compare', filter: 'formatFloat', isVisible: true, pageName: 'call-center'},
        {title: 'CallRail In calls', value: 'total_paid_callrail_answ', value_compare: 'total_paid_callrail_answ_compare', filter: 'formatFloat', isVisible: true, pageName: 'call-center'},
        {title: 'CallRail Outbound calls', value: 'total_paid_callrail_out', value_compare: 'total_paid_callrail_out_compare', filter: 'formatFloat', isVisible: true, pageName: 'call-center'},
        {title: 'CRM Leads', value: 'crm_leads', value_compare: 'crm_leads_compare', filter: 'formatFloat', isVisible: true, pageName: 'marketing-summary'},
        {title: 'Unique Events', value: 'uniq_events', value_compare: 'uniq_events_compare', filter: 'formatFloat', isVisible: true, pageName: 'marketing-summary'}
      ]
    }
  },
  watch: {
    isCompareFilter(){
      if (!this.isCompareFilter){
      let d = moment(this.dateStart)
      this.dateCompareEnd = new Date(
                              Date.UTC(
                                new Date(d).getFullYear(),
                                new Date(d).getMonth(),
                                new Date(d).getDate() - 1)
                              ).toISOString().substr(0, 10)

      this.dateCompareStart = new Date(
                                Date.UTC(
                                  new Date(d).getFullYear(),
                                  new Date(d).getMonth(),
                                  new Date(d).getDate() - this.diffDays)
                                ).toISOString().substr(0, 10)
      } else {
        this.applayCompares()
      }
    },
    dateStart(){
      this.countDiffDayes()
      this.countDateCompareEnd()
      this.countDateCompareStart()        
    },
    dateEnd(){
      this.countDiffDayes()
      this.countDateCompareEnd()
      this.countDateCompareStart()        
    }
  },
  created(){
    this.countDiffDayes()
    this.countDateCompareEnd()
    this.countDateCompareStart()
  },
  mounted() {
    let userName = localStorage.getItem('username')
    let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1

    let currentCardVersion = 7
    let cardsVersion = (localStorage.getItem(`${userName}.${clientId}.CountersCardVersion`))
                ? parseInt(localStorage.getItem(`${userName}.${clientId}.CountersCardVersion`))
                : 0

    if (currentCardVersion > cardsVersion) {
      localStorage.setItem(`${userName}.${clientId}.CountersCardVersion`, currentCardVersion.toString())
      this.saveState()
    }

    this.cards = (localStorage.getItem(`${userName}.${clientId}.CountersCards`))
                ? JSON.parse(localStorage.getItem(`${userName}.${clientId}.CountersCards`))
                : this.cards

    if (sessionStorage.getItem('dateStart')) {
      this.dateStart = sessionStorage.getItem('dateStart')
    }
    if (sessionStorage.getItem('dateEnd')) {
      this.dateEnd = sessionStorage.getItem('dateEnd')
    }

    this.loaded = true
    axios
        .get('/username')
        .then(response => (this.userName = response.data))
    axios
        .get('/dashboard/counters/' + this.dateStart + '/' + this.dateEnd)
        .then(response => {
          this.data = response.data

          this.loaded = false
        })
  },
  methods: {
    openPage(pageName){
        localStorage.setItem('fromCounterPage', JSON.stringify({
          dateStart: this.dateStart,
          dateEnd: this.dateEnd,
          defaultPeriod: this.defaultPeriod
        }))

        let routeData = this.$router.resolve({name: pageName})
        window.open(routeData.href, '_blank')
    },
    hideCard(card){
      card.isVisible = false;

      this.saveState()
    },
    showCard(card){
      card.isVisible = true;

      this.saveState()
    },
    saveState(){
      let userName = localStorage.getItem('username')
      let clientId = (localStorage.getItem('ClientId')) ? localStorage.getItem('ClientId') : 1

      const parsed = JSON.stringify(this.cards)
      localStorage.setItem(`${userName}.${clientId}.CountersCards`, parsed)
    },
    countDiffDayes(){
      const oneDay = 24 * 60 * 60 * 1000
      const firstDate = new Date(this.dateStart)
      const secondDate = new Date(this.dateEnd)

      this.diffDays =  Math.round(Math.abs((firstDate - secondDate) / oneDay)) + 1
    },
    countDateCompareEnd(){
      let d = moment(this.dateStart)

      this.dateCompareEnd = new Date(
                              Date.UTC(
                                new Date(d).getFullYear(),
                                new Date(d).getMonth(),
                                new Date(d).getDate() - 1)
                              ).toISOString().substr(0, 10)
    },
    countDateCompareStart(){
      let d = moment(this.dateStart)

      this.dateCompareStart = new Date(
                              Date.UTC(
                                new Date(d).getFullYear(),
                                new Date(d).getMonth(),
                                new Date(d).getDate() - this.diffDays)
                              ).toISOString().substr(0, 10)
    },
    getDates({ dateStart, dateEnd, compareMode }){
      this.dateStart = dateStart
      this.dateEnd = dateEnd
      this.isCompareFilter = compareMode
      this.applyFilters()
    },
    getCompareDates(dates){
      this.dateCompareStart = dates.dateStart
      this.dateCompareEnd = dates.dateEnd
      this.applayCompares()
    },
    applyFilters(){
      this.loaded = true
      axios
          .get('/dashboard/counters/' + this.dateStart + '/' + this.dateEnd)
          .then(response => {
            this.data = response.data
            this.result = this.data
            this.loaded = false
          })
    },
    applayCompares(){
      this.loadedCompare = true
      axios
          .get('/dashboard/counters/' + this.dateCompareStart + '/' + this.dateCompareEnd)
          .then(response => {
            this.dataCompare = response.data
            this.result = {}

            for (const [key, value] of Object.entries(this.data)) {
              this.result[key] = value
              this.result[`${key}_compare`] = value - this.dataCompare[key]
            }
            this.$forceUpdate()

            this.loadedCompare = false
      })      
    }
  },
  computed: {

  }
}
</script>

<style scoped>
  .text-card {
    font-size: 30px;
    text-align: center;
  }
  .pa-2{
    min-height: 150px;
  }
  .calls-card:hover a {
    color:white !important;
  }
  .row-table:hover{
    color: #3F51B5;
    cursor: default;
  }

  .row-table:nth-child(2n+2) {
    background-color: #F5F5F5;
  }

  .calls-text-card {
    font-size: 1.2em;
    text-align: left;
    color: black !important;
  }
  .calls-card {
    min-height: 130px;
    padding: 20px 40px;
    width: 32%;
  }

  .calls-card-title {
    font-size: 0.9em;
    color: black !important;
    word-break: keep-all;
  }
  @media (min-width: 960px) and (max-width: 980px) {
    .calls-card-title {
      word-break: break-all;
    }
  }
  @media (max-width: 600px) {
    .calls-card {
      width: 99% !important;
    }
  }
  @media (min-width: 601px) and (max-width: 959px) {
    .calls-card {
      width: 49% !important;
    }
  }
  .calls-card:hover {
    background-color: #3F51B5;
    color: white !important;
  }
  .calls-card:hover .calls-card-title, 
  .calls-card:hover .calls-text-card {
    color: white !important;
  }

  .compare-text {
    font-size: 0.87em !important;
  }
  .compare-icon {
    font-size: 0.95em !important;
  }
  .calls-card:hover .green--text {
    color: #A5D6A7 !important;
  }
  .calls-card:hover .red--text {
    color: #E57373 !important;
  }

</style>